export const insistenceSortingColumns = [
    'date',
    'insured',
    'debtor',
    'group',
    'country',
    'type',
    'policyTypeCode',
    'policy',
    'currency',
    'requestedAmountCents',
    'initialAmountTotal',
    'resultingAmountPermanent',
    'resultingAmountTemporary',
    'resultingAmountTotal',
    'answerDate',
];
export var InsistenceImportFailureReason;
(function (InsistenceImportFailureReason) {
    InsistenceImportFailureReason["Unknown"] = "unknown";
    InsistenceImportFailureReason["UnknownInsuranceCompany"] = "unknown_insurance_company";
    InsistenceImportFailureReason["UnknownInsistenceType"] = "unknown_insistence_type";
    InsistenceImportFailureReason["UnknownDate"] = "unknown_date";
    InsistenceImportFailureReason["UnknownSubscription"] = "unknown_subscription";
})(InsistenceImportFailureReason || (InsistenceImportFailureReason = {}));
